import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { Notifications, SetNotifications, Survay, SurveyQuestionAnswer } from '../models';

export enum AccountSettingsActionTypes {
  GetSurvaysAction = '[Survays] GetSurvaysAction',
  GetSurvaysSuccessAction = '[Survays] GetSurvaysSuccess',
  GetSurvaysErrorAction = '[Survays] GetSurvaysError',
  SetSurvaysAction = '[Survays] SetSurvaysAction',
  SetSurvaysSuccessAction = '[Survays] SetSurvaysSuccess',
  SetSurvaysErrorAction = '[Survays] SetSurvaysError',
  GetNotificationsAction = '[Notifications] GetNotificationsAction',
  GetNotificationsSuccessAction = '[Notifications] GetNotificationsSuccess',
  GetNotificationsErrorAction = '[Notifications] GetNotificationsError',
  SetNotificationsAction = '[Notifications] SetNotificationsAction',
  SetNotificationsSuccessAction = '[Notifications] SetNotificationsSuccess',
  SetNotificationsErrorAction = '[Notifications] SetNotificationsError',
  
  ClearStateAction = "[AccountSettings] ClearStateAction",
}

export const getSurvaysAction = createAction(AccountSettingsActionTypes.GetSurvaysAction);
export const getSurvaysSuccessAction = createAction(
  AccountSettingsActionTypes.GetSurvaysSuccessAction,
  props<{ survays: Survay[] }>()
);
export const getSurvaysErrorAction = createAction(
  AccountSettingsActionTypes.GetSurvaysErrorAction,
  props<{ failure: AppStateFailure }>()
);
export const setSurvaysAction = createAction(AccountSettingsActionTypes.SetSurvaysAction,
  props<{ surveyQuestionAnswers: SurveyQuestionAnswer }>());
export const setSurvaysSuccessAction = createAction(
  AccountSettingsActionTypes.SetSurvaysSuccessAction
);
export const setSurvaysErrorAction = createAction(
  AccountSettingsActionTypes.SetSurvaysErrorAction,
  props<{ failure: AppStateFailure }>()
);


export const getNotificationsAction = createAction(AccountSettingsActionTypes.GetNotificationsAction);
export const getNotificationsSuccessAction = createAction(
  AccountSettingsActionTypes.GetNotificationsSuccessAction,
  props<{ notifications: Notifications[] }>()
);
export const getNotificationsErrorAction = createAction(
  AccountSettingsActionTypes.GetNotificationsErrorAction,
  props<{ failure: AppStateFailure }>()
);
export const setNotificationsAction = createAction(AccountSettingsActionTypes.SetNotificationsAction,
  props<{ notifications: SetNotifications }>());
export const setNotificationsSuccessAction = createAction(
  AccountSettingsActionTypes.SetNotificationsSuccessAction
);
export const setNotificationsErrorAction = createAction(
  AccountSettingsActionTypes.SetNotificationsErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const ClearStateAction = createAction(AccountSettingsActionTypes.ClearStateAction, props<{actionType: string}>());